import { getCentroid } from './centroid'

import * as olGeom from 'ol/geom'

export function transformToGeometryCollection (geometry, appendCentroid) {
  // Si la geometry est déjà une collection, on n'y touche pas
  if (geometry.type === 'GeometryCollection') {
    return JSON.parse(JSON.stringify(geometry))
  }

  // Transforme la geometrie simple en collection
  const result = {
    type: 'GeometryCollection',
    geometries: [JSON.parse(JSON.stringify(geometry))],
  }

  // Si pas de centroid à calculer, retourne la collection
  if (!appendCentroid || ['Point', 'MultiPoint'].includes(geometry.type)) {
    return result
  }

  const centroid = getCentroid(new olGeom[geometry.type](geometry.coordinates))

  if (centroid) {
    result.geometries.push({
      type: 'Point',
      coordinates: centroid,
    })
  }

  return result
}
